import React, { useEffect, useState, useReducer } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import Button from "../components/ResubleComp/Button";
import Button1 from "../components/ResubleComp/Button";
import { ChatState } from "../ChatApp/Context/ChatProvider";
import { useDisclosure } from "@chakra-ui/react";
import { useToast } from "@chakra-ui/toast";
const baseUrl = process.env.REACT_APP_BASE_URL;
const AlluserProfile = () => {
  const params = useParams();
  const userID = params.userId;
  console.log("what is in params", params.userId);
  const token = localStorage.getItem("TOKEN");
  const [data, setdata] = useState("");

  const [following, setFollowing] = useState(false);
  const [update, forceUpdate] = useReducer((x) => x + 1, 0);

  const { setSelectedChat, user, chats, setChats } = ChatState();
  const [loadingChat, setLoadingChat] = useState(false);
  const { onClose } = useDisclosure();
  const toast = useToast();
  const uId = user && user._id;
  const userProfileRedirect = async () => {
    const uid = localStorage.getItem("userId");
    const userprofileUrl = `${baseUrl}/api/user/${userID}`;
    const response = await axios.get(userprofileUrl, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    setdata(response.data);
    if (response.data.followers.includes(uid)) setFollowing(true);
    console.log("responsefor profile", response.data);
  };
  useEffect(() => {
    userProfileRedirect();
  }, [update]);

  const handleFollowClick = async (useridd) => {
    console.log("userIdkyaha", useridd);
    const url = baseUrl + `/api/user/follow/${useridd}`;
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
    });
    const res = await response.json();
    forceUpdate();
    console.log("userfollow", res);
    return response;
  };

  let userId = localStorage.getItem("userId");

  const accessChat = async (userId) => {
    console.log(userId);

    try {
      setLoadingChat(true);
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: token,
        },
      };
      const { data } = await axios.post(
        `${baseUrl}/api/chat`,
        { userId },
        config
      );

      setChats([data, ...chats]);
      console.log("chatsssssss", data);

      setSelectedChat(data);
      setLoadingChat(false);
      // onClose();
    } catch (error) {
      toast({
        title: "Error fetching the chat",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
  };
  useEffect(() => {
    accessChat();
  }, [userId]);
  // const fetchChats = async () => {
  //   // console.log(user._id);
  //   try {
  //     const config = {
  //       headers: {
  //         Authorization:token,
  //       },
  //     };

  //     const { data } = await axios.get(baseUrl + "/api/chat", config);
  //     setChats(data);
  //   } catch (error) {
  //     toast({
  //       title: "Error Occured!",
  //       description: "Failed to Load the chats",
  //       status: "error",
  //       duration: 5000,
  //       isClosable: true,
  //       position: "bottom-left",
  //     });
  //   }
  // };
  // useEffect(() => {
  //   // setLoggedUser(JSON.parse(localStorage.getItem("userINfo")));
  //   fetchChats();
  //   // eslint-disable-next-line
  // }, [fetchAgain]);

  return (
    <div>
      <div className="bg-gradient-to-tr from-[#0000] to-[#0000]">
        <div
          className="md:p-2 md:mx-44"
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          <div className="w-full lg:w-1/2 md:w-full xl:w-1/2 2xl:w-1/2 mt-20 lg:mt-20 md:mt-20">
            <div className="bg-white rounded-lg shadow-xl flex border border-cyan-500 mt-5">
              <div className="flex items-start gap-15 flex-col justify-center m-10 relative w-full mb-3">
                <div className="flex gap-48">
                  <div className="left-container flex flex-col gap-7">
                    <img
                      className="border-2 shadow-xl w-[100px] h-[100px] rounded-full"
                      src={data.userProfileImageUrl}
                      alt="alt"
                    />
                    <span className="text-xl font-extrabold text-[22px] mt-[-10px]">
                      {data.name}
                      {/* <span
                        className="text-xs"
                        style={{ fontFamily: "sans-serif", fontWeight: "600" }}
                      >
                        {" "}
                        {data.typeofuser ? data.typeofuser : ""}
                      </span> */}
                    </span>
                  </div>
                </div>
                <div className="mt-[15px]">
                  <div className="flex flex-col gap-1">
                    <div className="text-gray-400 flex align-center text-xl	font-bold mt-[-8px]">
                      <span className="text-[15px] font-normal leading-5 text-black">
                        {data.about ? data.about : ""}
                      </span>
                    </div>
                    <div className="flex flex-col gap-4">
                      <div className="text-gray-400 mt-3">
                        <div>
                          {data.school && (
                            <p className="flex gap-3 items-center text-black font-normal text-sm ml-[6px]">
                              <img
                                src="https://img.freepik.com/free-icon/antique-elegant-building-with-columns_318-44861.jpg"
                                className="w-5 h-[18px]"
                                alt=""
                              />
                              {data.school}
                            </p>
                          )}
                          {data.education ? (
                            <p className="text-black flex gap-2 text-sm font-normal items-center">
                              <img
                                src="https://img.freepik.com/premium-vector/graduation-cap-symbol-education-illustration-design_92086-772.jpg?w=1060"
                                className="w-8"
                                alt=""
                              />
                              {data.education ? data.education : ""}
                            </p>
                          ) : null}
                          {data.location ? (
                            <p className="text-black flex gap-2 text-sm font-normal items-center mt-[-8px]">
                              <img
                                src="https://as2.ftcdn.net/v2/jpg/02/54/62/25/1000_F_254622588_6OClHyYpak64rVI8y9QVjUvDlStsDEu9.jpg"
                                className="w-8"
                                alt=""
                              />
                              {data.location ? data.location : ""}
                            </p>
                          ) : null}

                          {/* Message button and follow button */}
                        </div>
                        {/* {
                          token ? {data._id !== userId && (
                            <div className="flex gap-4">
                              <a href="/chatpage">
                                <Button1
                                  onClick={() => {
                                    accessChat(data._id);
                                  }}
                                  className="rounded-md px-3 py-1 mt-6 border-2 border-blue-500"
                                >
                                  Message
                                </Button1>
                              </a>
                            </div>
                          )}: {data._id !== userId && (
                            <div className="flex gap-4">
                              <a href="/usersignup">
                                <Button1
                                  onClick={() => {
                                    accessChat(data._id);
                                  }}
                                  className="rounded-md px-3 py-1 mt-6 border-2 border-blue-500"
                                >
                                  Message
                                </Button1>
                              </a>
                            </div>
                          )}
                        } */}
                        {token
                          ? data._id !== userId && (
                              <div className="flex gap-4">
                                <a href="/chatpage">
                                  <Button1
                                    onClick={() => {
                                      accessChat(data._id);
                                    }}
                                    className="rounded-md px-3 py-1 mt-6 border-2 border-blue-500"
                                  >
                                    Message
                                  </Button1>
                                </a>
                              </div>
                            )
                          : data._id !== userId && (
                              <div className="flex gap-4">
                                <a href="/usersignup">
                                  <Button1
                                    onClick={() => {
                                      accessChat(data._id);
                                    }}
                                    className="rounded-md px-3 py-1 mt-6 border-2 border-blue-500"
                                  >
                                    Message
                                  </Button1>
                                </a>
                              </div>
                            )}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col lg:flex-row gap-5 mt-3"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gradient-to-tr from-[#0000] to-[#0000]">
        <div
          className="md:p-2 md:mx-44"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            placeContent: "center",
          }}
        >
          <div className="w-full lg:w-1/2 md:w-full xl:w-1/2 2xl:w-1/2 mt-1 lg:mt-1 md:mt-1">
            {/* <div className="bg-white rounded-lg shadow-xl flex border border-cyan-500 mb-3 p-5 flex-col">
              <div className="mb-3 text-2xl font-medium">Interest &nbsp;</div>
              <p className="flex flex-wrap gap-4">
                <p className="text-sm text-gray-500">
                  {data.interests ? data.interests : ""}
                </p>
              </p>
            </div> */}
          </div>
          {data.isDomainExpert === true ? (
            <div className="w-full lg:w-1/2 md:w-full xl:w-1/2 2xl:w-1/2 mt-1 lg:mt-1 md:mt-1">
              <div className="bg-white rounded-lg shadow-xl flex border border-cyan-500 mb-3 p-5 flex-col">
                <div className="mb-3 text-2xl font-medium">
                  Domain Expertise &nbsp;
                </div>
                <div className="mb-3 text-2xl font-medium flex flex-wrap gap-2 ">
                  <p className="text-sm text-gray-500">{data.domainBio}</p>
                  {data.domainExpertise.map((dat) => {
                    return (
                      <>
                        <div className="gap-4 text-sm text-blue-500 cursor-pointer border-4">
                          {dat ? dat : ""}
                        </div>
                      </>
                    );
                  })}
                </div>
                <div className="flex flex-wrap gap-4">
                  {/* zedgocloud remove*/}
                  {token ? (
                    <a
                      href="/zegocloud"
                      className="bg-black w-full text-sm text-white pb-2 pt-2 rounded-md text-center"
                    >
                      <button>
                        Pay INR {data.sessionPrice ? data.sessionPrice : ""} to
                        start a session
                      </button>
                    </a>
                  ) : (
                    <a
                      href="/usersignup"
                      className="bg-black w-full text-sm text-white pb-2 pt-2 rounded-md text-center"
                    >
                      <button>
                        Pay INR {data.sessionPrice ? data.sessionPrice : ""} to
                        start a session
                      </button>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default AlluserProfile;
